import { getCarrierNamesOtcTemplate, getCarrierNamesPartBTemplate } from "../../shortcodes/templates";
import { addShortcodeToEditor, getSpanShortcodeWrapper } from "../../shortodeAddition";

const carrierNamesConfig = (tinymce, uuid, shortcodeOnClick, api, type) => {
  const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();
  let templateToAdd = null;

  if (type === "otc") {
    templateToAdd = getCarrierNamesOtcTemplate();
  } else if (type === "partb") {
    templateToAdd = getCarrierNamesPartBTemplate();
  }

  const shortcodeWrapper = getSpanShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd, "carrier-names", false);

  addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api, false);
};

export { carrierNamesConfig };
